module.exports = __webpack_public_path__ + "img/白鹤藤.96270874.jpg";